var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useInterval } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { v4 } from "uuid";
const cache = {};
const dataValidity = 60 * 60 * 1000;
export const useFetch = (url) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const [refresh, setRefresh] = useState(v4());
    useInterval(() => {
        setRefresh(v4());
    }, dataValidity);
    useEffect(() => {
        if (!url)
            return;
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            const currentDateTimestamp = new Date().getTime();
            if (cache[url] &&
                currentDateTimestamp - cache[url].timestamp < dataValidity) {
                setData(cache[url].data);
                setLoading(false);
                return;
            }
            const data = (yield fetch(url).then((res) => res.json()));
            cache[url] = {
                timestamp: currentDateTimestamp,
                data,
            };
            setData(data);
            setLoading(false);
        });
        fetchData();
    }, [url, refresh]);
    return { loading, data };
};
